import { Core } from './core';
import login from './api/login.js';
import enroll from './api/enroll';
import contact from './api/contact.js';
import home from './api/home';
import sign from './api/sign.js';
import myDoc from './api/myDoc.js';
import seal from './api/seal';
import bindUkey from './api/bindUkey';
import myTemp from './api/myTemp';
import template from './api/template';
import realName from './api/realName';
import user from './api/user';
import batch from './api/batch.js';

// 接口配置封装
const resourceApi = Core({
  contact,
  login,
  sign,
  enroll,
  home,
  myDoc,
  seal,
  bindUkey,
  template,
  myTemp,
  realName,
  user,
  batch
});

export default resourceApi;

// Config = {
//     // 接口
//     url: {
//         type: String,
//         required: true
//     },
//     // 方法
//     method: {
//         type: String,
//         default: 'GET'
//     },
//     // 接口参数配置
//     body: {
//         type: Object,
//         default: {}
//     },
//     // 请求模式 (fetch / 钉钉 ／ 微信 ／axios) 数组支持先后顺序 [钉钉,fetch]
//     mode: {
//         type: Array,
//         default: [fetch]
//     },
//     // 完成的回调
//     done: {
//         type: Function
//     }
// }


// post 例子
//  ResourceApi.login.add({
//     username: 'josh',
//     password: 1233
// }).then(res => {
//     console.log(res);
// });

// get 列子
// ResourceApi.login.get().then(res => {
//     console.log(res);
// });



// WEBPACK FOOTER //
// ./src/resource-api/index.js